(function () {
	const _slideshow = document.getElementById('slideshow');
	
	if (!_slideshow) {
		return;
	}
	
	const _navButtons = document.querySelectorAll('.js-slideshow-navigation-button');
	const _controlButton = document.getElementById('slideshow-control-button');
	
	let autoplayTimer;
	let autoplayPaused = true;
	let lastIndex = 0;
	let maxIndex = _navButtons.length - 1;
	
	function init() {
		//autoplayStart();
		autoplayPause();

		_slideshow.addEventListener('click', click);
		_slideshow.addEventListener('keydown', keydown);
		_slideshow.addEventListener('keyup', keyup);
	}
	
	function autoplayPause() {
		clearInterval(autoplayTimer);
		autoplayPaused = true;
		
		util.addClass(_controlButton, 'is-paused');
		util.removeClass(_controlButton, 'is-playing');
	}
	
	function autoplayStart() {
		if (autoplayTimer) {
			clearInterval(autoplayTimer);
		}
		
		autoplayTimer = setInterval(step, 10000);
		autoplayPaused = false;
		
		util.addClass(_controlButton, 'is-playing');
		util.removeClass(_controlButton, 'is-paused');
	}
	
	function change(index) {
		_navButtons[lastIndex].setAttribute('tabindex', -1);
		_navButtons[lastIndex].setAttribute('aria-selected', 'false');
		util.removeClass(_navButtons[lastIndex], 'is-active');
		
		const _lastActiveItem = document.getElementById(_navButtons[lastIndex].getAttribute('aria-controls'));
		
		_lastActiveItem.setAttribute('aria-hidden', 'true');
		util.removeClass(_lastActiveItem, 'is-visible');
		
		_navButtons[index].setAttribute('tabindex', 0);
		_navButtons[index].setAttribute('aria-selected', 'true');
		util.addClass(_navButtons[index], 'is-active');
		
		const _activeItem = document.getElementById(_navButtons[index].getAttribute('aria-controls'));
		
		_activeItem.setAttribute('aria-hidden', 'false');
		util.addClass(_activeItem, 'is-visible');
		
		lastIndex = index;
	}
	
	function click(event) {
		if (util.hasClass(event.target, 'js-slideshow-navigation-button')) {
			change(util.elementIndex(event.target));
			autoplayStart();
		}
		
		if (event.target.id == 'slideshow-control-button') {
			if (autoplayPaused) {
				autoplayStart();
			} else {
				autoplayPause();
			}
		}
	}
	
	function keydown(event) {
		if (util.hasClass(document.activeElement, 'js-slideshow-navigation-button') && (event.keyCode === 38 || event.keyCode === 40)) {
			event.preventDefault();
		}
	}
	
	function keyup(event) {
		if (!util.hasClass(document.activeElement, 'js-slideshow-navigation-button')) {
			return;
		}
		
		if (event.keyCode === 38) {
			autoplayPause();
			step(-1, true);
		} else if (event.keyCode === 40) {
			autoplayPause();
			step(1, true);
		}
	}
	
	function step(direction = 1, setFocus = false) {
		let index = lastIndex + direction;
		
		if (index < 0) {
			index = maxIndex;
		} else if (index > maxIndex) {
			index = 0;
		}
		
		change(index);
		
		if (setFocus) {
			_navButtons[index].focus();
		}
	}
	
	init();
}());